import { jsx as _jsx } from "react/jsx-runtime";
import { useI18n } from '@cta-portal/webapp-common/lib/hooks/translations/use-i18n';
import React, { useContext } from 'react';
import cancelIcon from '../../assets/images/icons/common/icon-trash-purple.png';
import acceptIcon from '../../assets/images/icons/common/icon-valid-dark.png';
import { CurrencyContext } from '../../context/currency';
import { UserContext } from '../../context/user';
import { formatDate } from '../../utils/date';
import Table, { CellAlign, CellType } from '../common/table';
export default function OrdersTable(_a) {
    var offers = _a.offers, ownedByUser = _a.ownedByUser, cancelOfferAction = _a.cancelOfferAction, acceptOfferAction = _a.acceptOfferAction;
    var _b = useI18n(), t = _b.t, i18n = _b.i18n;
    var selectedWallet = useContext(UserContext).selectedWallet;
    var parseCurrencyQuantity = useContext(CurrencyContext).parseCurrencyQuantity;
    var labels = [
        {
            key: 'date',
            label: t('common.date'),
            align: CellAlign.LEFT,
            size: 1,
            mobileSize: 0.6,
        },
        {
            key: 'buyer',
            label: t('common.buyer'),
            align: CellAlign.LEFT,
            size: 1,
        },
        { key: 'price', label: t('common.offer'), align: CellAlign.RIGHT, size: 1, mobileSize: 1.2 },
        {
            key: 'action',
            label: t('common.actions'),
            align: CellAlign.CENTER,
            size: 1,
            mobileSize: 1.2,
            actionCell: true,
        },
    ];
    var actions = [
        {
            label: t('common.cancel'),
            icon: cancelIcon,
            withoutDesktopIcon: true,
            action: function (id) { return cancelOfferAction(Number.parseInt(id)); },
            generateDisability: function (id) {
                var offer = offers.find(function (elem) { return elem.order_id.toString() === id; });
                return !(offer && offer.user === (selectedWallet === null || selectedWallet === void 0 ? void 0 : selectedWallet.address));
            },
        },
    ];
    if (ownedByUser) {
        actions.push({
            label: t('common.accept'),
            highlighted: true,
            icon: acceptIcon,
            withoutDesktopIcon: true,
            action: function (id) { return acceptOfferAction(Number.parseInt(id)); },
        });
    }
    var rows = offers
        .filter(function (offer) { return !ownedByUser || offer.user !== (selectedWallet === null || selectedWallet === void 0 ? void 0 : selectedWallet.address); })
        .map(function (offer) {
        var _a, _b, _c;
        var price = parseCurrencyQuantity(offer.sell.data.quantity_with_fees, offer.sell.data.token_address);
        return {
            id: offer.order_id.toString(),
            data: {
                date: {
                    type: CellType.TEXT,
                    value: formatDate(offer.updated_timestamp || '', i18n.language),
                },
                buyer: { type: CellType.TEXT, value: "".concat(offer.user.slice(0, 5), "...").concat(offer.user.slice(-4)) },
                price: {
                    type: CellType.PRICE,
                    value: {
                        tokenSymbol: (_a = price.base) === null || _a === void 0 ? void 0 : _a.symbol,
                        value: ((_b = price.base) === null || _b === void 0 ? void 0 : _b.displayValue) || '0',
                        usdValue: ((_c = price.usd) === null || _c === void 0 ? void 0 : _c.displayValue) || '0',
                    },
                },
            },
        };
    });
    return _jsx(Table, { actions: actions, labels: labels, notRounded: true, rows: rows });
}
